import React from "react";

export default function Navbar(props) {
  return (
    <>
      <nav
        className="navbar position-fixed navbar-expand-lg navbar-light shadow-sm p-3 bg-body"
        style={{ width: "100%", zIndex: "100" }}
      >
        <div className="container fw-semibold">
          <a className="navbar-brand fw-semibold" href="/">
            <img src={require("../../assets/logo.png")} alt="logo" width={40} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarScroll"
            aria-controls="navbarScroll"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarScroll">
            <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll">
              <li className="nav-item">
                <a
                  className={
                    props.isActive === "beranda"
                      ? "nav-link fw-bold text-danger text-decoration-underline"
                      : "nav-link"
                  }
                  aria-current="page"
                  href="/"
                >
                  Beranda
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={
                    props.isActive === "tentangkami"
                      ? "nav-link fw-bold text-danger text-decoration-underline"
                      : "nav-link"
                  }
                  aria-current="page"
                  href="/tentang-kami"
                >
                  Tentang Kami
                </a>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="/"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Layanan
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="/aplikasi-phoenix">
                      Aplikasi Phoenix
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/outsourcing">
                      Outsourcing
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/online-offline-distribution"
                    >
                      Online & Offline Distribution
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/whatsapp-api">
                      NusaCRM
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/eventMice">
                      EVENT MICE
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a
                  className={
                    props.isActive === "hubungikami"
                      ? "nav-link fw-bold text-danger text-decoration-underline"
                      : "nav-link"
                  }
                  href="/hubungi-kami"
                >
                  Hubungi Kami
                </a>
              </li>
            </ul>
            <form className="d-flex">
              <input
                className="form-control ms-auto me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-secondary" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
    </>
  );
}
